"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveResultsCount = exports.scrollbarWidth = exports.fuzzyTextFilterFn = exports.IndeterminateCheckbox = exports.NumberRangeColumnFilter = exports.SliderColumnFilter = exports.SelectColumnFilter = exports.DefaultColumnFilter = exports.DateCell = exports.ExpandableCell = exports.EditableCell = exports.ActionCell = exports.dateCsvGetter = exports.convertISOtoLocal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _matchSorter = require("match-sorter");

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _material = require("@mui/material");

var _moment = _interopRequireDefault(require("moment"));

var _iconsMaterial = require("@mui/icons-material");

var _luxon = require("luxon");

var _excluded = ["indeterminate"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Create an editable cell renderer
var EditableCell = function EditableCell(_ref) {
  var initialValue = _ref.value,
      index = _ref.row.index,
      id = _ref.column.id,
      updateData = _ref.updateData,
      editable = _ref.editable;

  // We need to keep and update the state of the cell normally
  var _useState = (0, _react.useState)(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = function onChange(e) {
    setValue(e.target.value);
  }; // We'll only update the external data when the input is blurred


  var onBlur = function onBlur() {
    updateData(index, id, value);
  }; // If the initialValue is changed externall, sync it up with our state


  (0, _react.useEffect)(function () {
    setValue(initialValue);
  }, [initialValue]);

  if (!editable) {
    return "".concat(initialValue);
  }

  return /*#__PURE__*/_react.default.createElement(_material.TextField, {
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    variant: "outlined",
    size: "small"
  });
}; // Create an editable cell renderer


exports.EditableCell = EditableCell;

var DateCell = function DateCell(_ref2) {
  var initialValue = _ref2.value,
      index = _ref2.row.index,
      id = _ref2.column.id;

  // We need to keep and update the state of the cell normally
  var _useState3 = (0, _react.useState)(initialValue),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1]; // If the initialValue is changed externall, sync it up with our state


  (0, _react.useEffect)(function () {
    setValue(initialValue);
  }, [initialValue]);
  return value && value.length ? convertISOtoLocal(value) : value;
};

exports.DateCell = DateCell;

var convertISOtoLocal = function convertISOtoLocal(dateISO) {
  var zone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utc';
  var outputformat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _luxon.DateTime.DATETIME_MED_WITH_SECONDS;

  var dt = _luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).toLocal();

  return dt.toLocaleString(outputformat);
};

exports.convertISOtoLocal = convertISOtoLocal;

var dateCsvGetter = function dateCsvGetter(row, value) {
  return convertISOtoLocal(value);
}; // Create an editable cell renderer


exports.dateCsvGetter = dateCsvGetter;

var ActionCell = function ActionCell(_ref3, icon, action) {
  var initialValue = _ref3.value;

  // We need to keep and update the state of the cell normally
  var _useState5 = (0, _react.useState)(initialValue),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1]; // If the initialValue is changed externall, sync it up with our state


  (0, _react.useEffect)(function () {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: function onClick() {
      return action(value);
    }
  }, icon && icon());
};

exports.ActionCell = ActionCell;

var ExpandableCell = function ExpandableCell(_ref4) {
  var initialValue = _ref4.value;

  // We need to keep and update the state of the cell normally
  var _useState7 = (0, _react.useState)(initialValue),
      _useState8 = _slicedToArray(_useState7, 2),
      value = _useState8[0],
      setValue = _useState8[1];

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1]; // If the initialValue is changed externall, sync it up with our state


  (0, _react.useEffect)(function () {
    setValue(initialValue);
  }, [initialValue]);

  var handleClick = function handleClick() {
    setOpen(!open);
  };

  var valueArray = Array.isArray(value) ? value : Boolean(value) ? [value] : [];
  return valueArray.length > 0 ? /*#__PURE__*/_react.default.createElement(_material.List, {
    sx: {
      minWidth: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_material.ListItemButton, {
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    }
  }, valueArray.join(',')), open ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.ExpandLess, {
    sx: {
      height: '0.8em',
      width: '0.8em'
    }
  }) : /*#__PURE__*/_react.default.createElement(_iconsMaterial.ExpandMore, {
    sx: {
      height: '0.8em',
      width: '0.8em'
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement("ul", {
    style: {
      listStyleType: "disc"
    }
  }, valueArray.map(function (val, i) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i
    }, val);
  })))) : valueArray;
}; // Define a default UI for filtering


exports.ExpandableCell = ExpandableCell;

var DefaultColumnFilter = function DefaultColumnFilter(_ref5) {
  var _ref5$column = _ref5.column,
      filterValue = _ref5$column.filterValue,
      preFilteredRows = _ref5$column.preFilteredRows,
      setFilter = _ref5$column.setFilter;
  return /*#__PURE__*/_react.default.createElement(_material.TextField, {
    value: filterValue || '',
    onChange: function onChange(e) {
      setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
    },
    size: "small",
    variant: "outlined",
    sx: {
      '& .MuiInputBase-inputSizeSmall': {
        height: '20px',
        padding: '0.25rem',
        fontSize: '0.8rem'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        width: '80%'
      }
    }
  });
}; // This is a custom filter UI for selecting
// a unique option from a list


exports.DefaultColumnFilter = DefaultColumnFilter;

var SelectColumnFilter = function SelectColumnFilter(_ref6) {
  var _ref6$column = _ref6.column,
      filterValue = _ref6$column.filterValue,
      setFilter = _ref6$column.setFilter,
      preFilteredRows = _ref6$column.preFilteredRows,
      id = _ref6$column.id;

  var _useState9 = (0, _react.useState)(filterValue ? filterValue : ''),
      _useState10 = _slicedToArray(_useState9, 2),
      value = _useState10[0],
      setValue = _useState10[1];

  var handleOnChange = function handleOnChange(event) {
    setFilter(event.target.value);
    setValue(event.target.value);
  }; // Calculate the options for filtering
  // using the preFilteredRows


  var options = (0, _react.useMemo)(function () {
    var options = new Set();
    preFilteredRows.forEach(function (row) {
      options.add(row.values[id]);
    });
    return _toConsumableArray(options.values());
  }, [id, preFilteredRows]);
  return /*#__PURE__*/_react.default.createElement(_material.Select, {
    value: value,
    onChange: handleOnChange,
    displayEmpty: true,
    size: "small",
    sx: {
      '& .MuiSelect-select': {
        height: '20px',
        padding: '0.25rem',
        fontSize: '0.8rem'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    value: "",
    sx: {
      fontSize: '0.8rem'
    }
  }, "All"), options.map(function (option, i) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: i,
      value: option,
      sx: {
        fontSize: '0.8rem'
      }
    }, option);
  }));
}; // This is a custom filter UI that uses a
// slider to set the filter value between a column's
// min and max values


exports.SelectColumnFilter = SelectColumnFilter;

var SliderColumnFilter = function SliderColumnFilter(_ref7) {
  var _ref7$column = _ref7.column,
      filterValue = _ref7$column.filterValue,
      setFilter = _ref7$column.setFilter,
      preFilteredRows = _ref7$column.preFilteredRows,
      id = _ref7$column.id;

  // Calculate the min and max
  // using the preFilteredRows
  var _useMemo = (0, _react.useMemo)(function () {
    var min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    var max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    preFilteredRows.forEach(function (row) {
      min = Math.min(row.values[id], min);
      max = Math.max(row.values[id], max);
    });
    return [min, max];
  }, [id, preFilteredRows]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      min = _useMemo2[0],
      max = _useMemo2[1];

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "range",
    min: min,
    max: max,
    value: filterValue || min,
    onChange: function onChange(e) {
      setFilter(parseInt(e.target.value, 10));
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setFilter(undefined);
    }
  }, "Off"));
}; // This is a custom UI for our 'between' or number range
// filter. It uses two number boxes and filters rows to
// ones that have values between the two


exports.SliderColumnFilter = SliderColumnFilter;

var NumberRangeColumnFilter = function NumberRangeColumnFilter(_ref8) {
  var _ref8$column = _ref8.column,
      _ref8$column$filterVa = _ref8$column.filterValue,
      filterValue = _ref8$column$filterVa === void 0 ? [] : _ref8$column$filterVa,
      preFilteredRows = _ref8$column.preFilteredRows,
      setFilter = _ref8$column.setFilter,
      id = _ref8$column.id;

  var _useMemo3 = (0, _react.useMemo)(function () {
    var min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    var max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    preFilteredRows.forEach(function (row) {
      min = Math.min(row.values[id], min);
      max = Math.max(row.values[id], max);
    });
    return [min, max];
  }, [id, preFilteredRows]),
      _useMemo4 = _slicedToArray(_useMemo3, 2),
      min = _useMemo4[0],
      max = _useMemo4[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    value: filterValue[0] || '',
    type: "number",
    onChange: function onChange(e) {
      var val = e.target.value;
      setFilter(function () {
        var old = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return [val ? parseInt(val, 10) : undefined, old[1]];
      });
    },
    placeholder: "Min (".concat(min, ")"),
    style: {
      width: '70px',
      marginRight: '0.5rem'
    }
  }), "to", /*#__PURE__*/_react.default.createElement("input", {
    value: filterValue[1] || '',
    type: "number",
    onChange: function onChange(e) {
      var val = e.target.value;
      setFilter(function () {
        var old = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return [old[0], val ? parseInt(val, 10) : undefined];
      });
    },
    placeholder: "Max (".concat(max, ")"),
    style: {
      width: '70px',
      marginRight: '0.5rem'
    }
  }));
};

exports.NumberRangeColumnFilter = NumberRangeColumnFilter;

var fuzzyTextFilterFn = function fuzzyTextFilterFn(rows, id, filterValue) {
  return (0, _matchSorter.matchSorter)(rows, filterValue, {
    keys: [function (row) {
      return row.values[id];
    }]
  });
}; // Let the table remove the filter if the string is empty


exports.fuzzyTextFilterFn = fuzzyTextFilterFn;

fuzzyTextFilterFn.autoRemove = function (val) {
  return !val;
};

var IndeterminateCheckbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref9, ref) {
  var indeterminate = _ref9.indeterminate,
      rest = _objectWithoutProperties(_ref9, _excluded);

  var defaultRef = (0, _react.useRef)();
  var resolvedRef = ref || defaultRef;
  (0, _react.useEffect)(function () {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Checkbox, _extends({
    size: "small",
    sx: {
      p: 0,
      pb: "1px",
      '&.Mui-checked': {
        color: "#ff562b"
      }
    },
    ref: resolvedRef
  }, rest)));
});
exports.IndeterminateCheckbox = IndeterminateCheckbox;

var scrollbarWidth = function scrollbarWidth() {
  var scrollDiv = document.createElement('div');
  scrollDiv.setAttribute('style', 'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;');
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

exports.scrollbarWidth = scrollbarWidth;

var resolveResultsCount = function resolveResultsCount(pageIndex, pageSize, rowLength) {
  var minIndex = pageIndex * pageSize + 1;
  var maxIndex = (pageIndex + 1) * pageSize;
  var resolveMaxIndex = maxIndex > rowLength ? rowLength : maxIndex;
  return "Results ".concat(minIndex, " - ").concat(resolveMaxIndex, " out of ").concat(rowLength);
};

exports.resolveResultsCount = resolveResultsCount;